export async function fetchMenus(query: SearchParameters = {}) {
  const {
    attributes: menus,
    pending,
    error,
    refresh,
  } = await useApiFetch<Menu[]>('/api/v1/cms/menus', { query }, false)
  return { menus, pending, error, refresh }
}
